import { render, staticRenderFns } from "./studentLearning.vue?vue&type=template&id=7d33b018&scoped=true"
import script from "./studentLearning.vue?vue&type=script&lang=js"
export * from "./studentLearning.vue?vue&type=script&lang=js"
import style0 from "./studentLearning.vue?vue&type=style&index=0&id=7d33b018&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33b018",
  null
  
)

export default component.exports